import React, { useState, useEffect } from 'react';

const usePopup = () => {
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        document.addEventListener('click', handleBackgroundClick);
        document.addEventListener('keydown', handleKeyPress);

        return () => {
            document.removeEventListener('click', handleBackgroundClick);
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, []);

    const handleBackgroundClick = (event: Event) => {
        const target = event.target as HTMLTextAreaElement;

        if (target.closest('.popup-content')) {
            setShowPopup(false);
        }
    };

    const handleKeyPress = (event: { key: string }) => {
        if (event.key === 'Escape') {
            setShowPopup(false);
        }
    };

    const togglePopup = () => {
        setShowPopup(!showPopup);
    };

    return [showPopup, togglePopup] as const;
};

export default usePopup;
